import { Flex } from '@chakra-ui/react';
import React from 'react';

import { useProviderSelectionContext } from 'Contexts/providerSelectionContext';
import { useTextContext } from 'Contexts/textContext';
import Plan from 'Models/plan';
import { DoctorType } from 'Types/entities';

import { ProviderTag } from '..';

interface RenderProvidersProps {
  plan: Plan;
  inNetwork: boolean;
}

export const useProviderListByNetwork = (plan: Plan, inNetwork: boolean) => {
  const { filteredProviders } = useProviderSelectionContext();
  const { planId } = plan;
  const providersSelected =
    filteredProviders[planId] &&
    (filteredProviders[planId].inNetwork.length > 0 || filteredProviders[planId].outOfNetwork.length > 0);
  if (!providersSelected) return { providerList: [] };
  const providerList = filteredProviders[planId]
    ? inNetwork
      ? filteredProviders[planId].inNetwork
      : filteredProviders[planId].outOfNetwork
    : [];
  return { providerList };
};

const RenderProvidersComponent: React.FC<RenderProvidersProps> = ({ plan, inNetwork }) => {
  const { providerList } = useProviderListByNetwork(plan, inNetwork);
  const type = inNetwork ? 'in-network' : 'out-of-network';
  const { retrieveContentfulData } = useTextContext();
  const noneText = retrieveContentfulData<string>('health_section.recommendation.in_network_providers_none');

  return (
    <Flex gap={1} flexWrap="wrap">
      {providerList.length > 0 ? (
        providerList.map((provider: DoctorType, index) => {
          const fullName = [provider.first_name, provider.middle_name, provider.last_name]
            .filter(Boolean)
            .join(' ');

          return (
            <ProviderTag providerDetail={fullName} key={provider.npi} testId={`${type}-compare-${index}`} />
          );
        })
      ) : (
        <ProviderTag providerDetail={noneText} testId={`${type}-compare-none`} />
      )}
    </Flex>
  );
};

export default RenderProvidersComponent;
